<template>
  <div :class="['min-max-inputs-wrapper', customClasses]">
    <input-item :customError="minError"
                :inputClass="minInput.class"
                :inputId="minInput.id"
                :inputType="minInput.inputType"
                :inputValue="minValue"
                :labelText="minInput.labelText"
                :shouldSetInteractions="shouldSetInteractions"
                :showErrors="showErrors"
                :useCustomValidation="useCustomValidation"
                :zeroAllowed="zeroAllowed"
                @saveInputValue="saveInputMin"
                @setErrors="setInputErrors"
                @setInteractions="setInteractions"></input-item>

    <input-item :customError="maxError"
                :inputClass="maxInput.class"
                :inputId="maxInput.id"
                :inputType="maxInput.inputType"
                :inputValue="maxValue"
                :labelText="maxInput.labelText"
                :shouldSetInteractions="shouldSetInteractions"
                :showErrors="showErrors"
                :useCustomValidation="useCustomValidation"
                @saveInputValue="saveInputMax"
                @setErrors="setInputErrors"
                @setInteractions="setInteractions"></input-item>
  </div>
</template>


<script>
  import NumberInput from './NumberInput'
  import InputItem from './InputItem'

  export default {
    props: {
      customClasses: String,
      maxInput: Object,
      minInput: Object,
      shouldSetInteractions: Boolean,
      showErrors: Boolean,
      useCustomValidation: Boolean,
      zeroAllowed: Boolean,
    },

    name: 'MinMaxInputs',

    components: {
      InputItem,
      NumberInput,
    },

    data() {
      return {
        maxError: null,
        maxValue: null,
        minError: null,
        minValue: null,
      }
    },

    methods: {
      saveInputMax(inputItem) {
        this.maxValue = inputItem[this.maxInput.id]
        const error = { errorKey: 'maxError', text: 'maximum days must be more than minimum days' },
          shouldUpdateBoth = this.minInput.value !== this.minValue

        this.validateMinMax({[this.maxInput.id]: this.maxValue}, error, shouldUpdateBoth)
      },

      saveInputMin(inputItem) {
        this.minValue = inputItem[this.minInput.id]
        const error = { errorKey: 'minError', text: 'minimum days must be less than maximum days' },
          shouldUpdateBoth = this.maxInput.value !== this.maxValue

        this.validateMinMax({[this.minInput.id]: this.minValue}, error, shouldUpdateBoth)
      },

      setInputErrors(errorKey, errorMessage) {
        this.$emit('setErrors', errorKey, errorMessage)
      },

      setInteractions(item) {
        this.$emit('setInteractions', item)
      },

      validateMinMax(dataToUpdate, error, shouldUpdateBoth) {
        const data = shouldUpdateBoth ? this.minMaxUpdateData : dataToUpdate
        if (parseInt(this.maxValue) > parseInt(this.minValue)) {
          if (shouldUpdateBoth) {
            this.maxError = null
            this.minError = null
          } else {
            this[error.errorKey] = null
          }
          this.$emit('setErrors', 'minmax', null)
          this.$emit('saveInputValue', data)
        } else {
          this.$emit('setErrors', 'minmax', error.text)
          this[error.errorKey] = error.text
        }
      },
    },

    created() {
      this.maxValue = this.maxInput.value
      this.minValue = this.minInput.value
    },

    computed: {
      minMaxUpdateData: function() {
        if (this.maxInput && this.minInput) {
          return {[this.maxInput.id]: this.maxValue, [this.minInput.id]: this.minValue}
        }
      },
    },
  }
</script>
